module.exports = __webpack_public_path__ + "img/jwgl-kbcx-mzkb.7b3a267d.png";